import Layout4Admin1 from "components/layout/Layout4Admin1";
import Css from './Customer.module.css';
import {useParams, useNavigate } from "react-router-dom";
import ApiConection from "api_ref/ApiConection";
import { useEffect, useState } from "react";
import { Form,Button, Col, Row, Breadcrumb, InputGroup } from "react-bootstrap";
import { AddCommar, ConvertDateTimeToText, ConvertDateToText, TextDate } from "components/MyControl";
import Swal from "sweetalert2";
import moment from "moment";

export default function CouponDetail(){

    const api = new ApiConection();
    const navigate = useNavigate();
    const { id } = useParams();
    const [validated, setValidated] = useState(false);
    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState('view');
    const [initialData, setInitialData] = useState({});
    const [calculatedPrices, setCalculatedPrices] = useState([]);
    const [simulate, setSimulate] = useState({
        code:'',
        name:'',
        type: 'CASH',
        discount:0,
        is_maximum:false,
        maximum_discount:0,
        start_date:null,
        end_date:null,
        is_infinite_amount:true,
        amount:0,
        active: false,
    });

    const [packagePeriod, setPackagePeriod] = useState([]);
    const [packageFeature, setPackageFeature] = useState([]);
    const [packageSupport, setPackageSupport] = useState([]);
    const [packagePremiums, setPackagePremiums] = useState([]);
    const [createMode,setCreateMode] = useState(false);
    const urlPathName = window.location.pathname;

    const handleSetSimulate = async (event) => {
        const { name, value, checked, type } = event.target;

 
        if(type === 'checkbox'){
            setSimulate(preData => { return { ...preData, [name]: checked } });
        }else{
            let output = value;

            if(name ==='discount')
                output = setDicount(value);
           
            if(type === 'number')
                output = parseFloat(output);
    
            setSimulate(preData => { return { ...preData, [name]: output } });
        }
        
    }


    const getData = async () => {
        const response = await api.getData(`api/coupon/${id}`);
        if (response.status === true) {
            let data = response.data;
            if(data?.start_date !== null) data.start_date = moment(data?.start_date, 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY');
            if(data?.end_date !== null) data.end_date = moment(data?.end_date, 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY');

            setSimulate(data);
            setInitialData(data);
        } 
    };
    

    const handleCancel = (event) => {
        if (createMode) {
            navigate('/coupon'); 
        }else{
            setSimulate(initialData)
            setMode('view')
        }
    }

    const handleBreadcrumbClick = (e) => {
        navigate('/coupon');
    };



    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        setValidated(false);
        setAlert('');
        setLoading(true);

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            setLoading(false);
            return;
        }

        let customInValid = false;

        if(convertStringToDate(simulate?.start_date) === 'Invalid date'){
            customInValid = true;
            document.querySelector(`[name=start_date]`)?.setCustomValidity('invalid');
        }

        if(convertStringToDate(simulate?.end_date) === 'Invalid date'){
            customInValid = true;
            document.querySelector(`[name=end_date]`)?.setCustomValidity('invalid');
        }

        if(customInValid){
            event.stopPropagation();
            setValidated(true);
            setLoading(false);
            return;
        }else{
            document.querySelector(`[name=start_date]`).setCustomValidity('');
            document.querySelector(`[name=end_date]`).setCustomValidity('');
        }

        let request = {
            code : simulate?.code,
            name : simulate?.name,
            type : simulate?.type,
            discount : simulate?.discount,
            is_maximum : simulate?.is_maximum,
            maximum_discount : simulate?.maximum_discount,
            start_date : null,
            end_date : null,
            is_infinite_amount : simulate?.is_infinite_amount,
            amount : simulate?.amount,
            active : simulate?.active,
        }

        let start_date = moment(simulate?.start_date, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss');
        let end_date = moment(simulate?.end_date, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss');

        if(start_date !== 'Invalid date') request.start_date = start_date;
        if(end_date !== 'Invalid date') request.end_date = end_date;

        if (urlPathName === (process.env.PUBLIC_URL+'/coupon/create')){
            const response = await api.postData(`api/coupon`, request)
            if (response.status === true) {
                navigate('/coupon');
            } else{
                setAlert(response.message);
            }
        }else{
            const response = await api.putData(`api/coupon/${id}`,request);
            
            if (response.status === true) {
                Swal.fire({title:'บันทึกสำเร็จ', icon:'success',heightAuto: false});
                await getData();
                setMode('view');
            } else {
                Swal.fire({title:'บันทึกไม่สำเร็จ', icon:'error',heightAuto: false});
                setAlert(response.message);
                setMode('edit');
            }
        }

        setLoading(false);
    }


    const getDicount = (value)=>{

        let output = 0;
        if(simulate?.type === 'PERCENT'){
            output = parseFloat(value) * 100;
        }else{
            output = parseFloat(value);
        }

        return output;
    }

    const setDicount = (value)=>{

        let output = 0;
        if(simulate?.type === 'PERCENT'){
            output = parseFloat(value) /100;
        }else{
            output = parseFloat(value);
        }

        return output;
    }

    const convertStringToDate =(value)=>{
        console.log('value=',value);
        if(value === '' || value === null) return '';
        return moment(value, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss');
    }

    useEffect(() => {
        if(mode === 'view'){
            getData();
        }
    }, [mode])

    useEffect(() => {
        if (urlPathName === (process.env.PUBLIC_URL+'/coupon/create')){
            setMode('edit');
            setCreateMode(true);
        }
        
    },[urlPathName])

    return(
        <Layout4Admin1 role="admin">
            <div className={Css.Block_Transparent}>
                <div className='contrainermt-3 mb-3'>
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={handleBreadcrumbClick}>รายการคูปองส่วนลด</Breadcrumb.Item>
                        <Breadcrumb.Item active>
                            {
                                mode === 'view' ? 'ข้อมูลคูปอง' :
                                createMode === true ? 'สร้างคูปอง' :
                                'แก้ไขคูปอง'
                            }
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <Form noValidate validated={validated} onSubmit={event => handleSubmit(event)} >
                        <div className={`border rounded p-4 bg-white shadow w-100`}>
                            <div>
                                <Row>
                                    <Col>
                                        <h5 className='text-start mb-0'>
                                            {
                                                mode === 'view' ? 'ข้อมูลคูปอง' :
                                                createMode === true ? 'สร้างคูปอง' :
                                                'แก้ไขคูปอง'
                                            }
                                        </h5>
                                        <Form.Text className="mb-5">ข้อมูลตัวแปรต่างๆ ที่ระบบ หรือโปรแกรมใช้งาน เมื่อทำการบันทึก จะมีผลกับระบบทันที</Form.Text>
                                    </Col>
                                    <Col className='text-end'>
                                        {
                                            mode === 'view' &&
                                            <Button variant="outline-secondary" type="button" className=''
                                                onClick={event => setMode('edit')}>
                                                แก้ไข
                                                <i className="ms-2 fa-solid fa-pencil"></i>
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                            </div>
                            <div className="mt-5">
                                <Row className='mb-5'>
                                    <Col className="me-3">
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>รหัสคูปอง</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view'|| createMode !== true) ? true : false}
                                                readOnly={(mode === 'view' || createMode !== true) ? true : false}
                                                className=''
                                                name={'code'}
                                                value={simulate?.code}
                                                onChange={handleSetSimulate}
                                                placeholder="รหัสคูปอง" required={true} />
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>รายละเอียด</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'name'}
                                                value={simulate?.name}
                                                onChange={handleSetSimulate}
                                                placeholder="รายละเอียด" required={true} />
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>ประเภท</Form.Label>
                                            {
                                                mode === 'view' &&
                                                <Form.Label className='d-block pt-2 pb-1 '>{simulate?.type}</Form.Label>
                                            }
                                            {
                                                mode === 'edit' &&
                                                <Form.Select 
                                                    name={'type'}
                                                    value={simulate?.type}
                                                    required={true}
                                                    placeholder="ประเภท"
                                                    onChange={handleSetSimulate} >
                                                        <option value={''}>--Please Select--</option>
                                                        <option value={'CASH'}>CASH</option>
                                                        <option value={'PERCENT'}>PERCENT</option>
                                                </Form.Select>
                                            }
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>จำนวนส่วนลด
                                                {
                                                    simulate?.type === 'PERCENT' &&
                                                    <span> (%)</span>
                                                }
                                                
                                            </Form.Label>
                                            <InputGroup>
                                                <Form.Control type='number' 
                                                    readOnly={(mode === 'view') ? true : false}
                                                    disabled={(mode === 'view') ? true : false}
                                                    name={'discount'}
                                                    value={getDicount(simulate?.discount)}
                                                    placeholder="0.00"
                                                    onChange={handleSetSimulate}
                                                    min={0}
                                                    max={simulate?.type === 'PERCENT'? 100 : 1000000}
                                                    maxLength={7}
                                                    required={true} />
                                                {
                                                    simulate?.type === 'PERCENT' &&
                                                    <>
                                                     <InputGroup.Text>%</InputGroup.Text>
                                                     <Form.Control.Feedback type="invalid">เปอนร์เซ็นต์กำหนดได้ตั้งแต่ 0-100%!</Form.Control.Feedback>
                                                    </>
                                                   
                                                }
                                                
                                                
                                            </InputGroup>
                                            
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>ลดสูงสุดไม่เกิน (บาท)</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Checkbox name='is_maximum' checked={simulate?.is_maximum} onChange={handleSetSimulate} disabled={(mode === 'view') ? true : false} />
                                                <Form.Control type='number' 
                                                    name={'maximum_discount'} 
                                                    disabled={(mode === 'view' || !simulate?.is_maximum) ? true : false} 
                                                    min={0}
                                                    max={1000000} 
                                                    value={simulate?.maximum_discount}
                                                onChange={handleSetSimulate} />
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>วันที่เริ่มต้น</Form.Label>
                                            {
                                                mode === 'view' &&
                                                <Form.Label as={Row} className="ms-1"  >{(simulate?.start_date === null)? '-' : simulate?.start_date}</Form.Label>
                                            }
                                            {
                                                mode ==='edit' &&
                                                <>
                                                    <TextDate   name="start_date" 
                                                        value={(simulate?.start_date)}
                                                        placeholder="วันที่เริ่มต้น"
                                                        onChange={handleSetSimulate} />
                                                    <Form.Control.Feedback type="invalid">วันที่ไม่ถูกต้อง!</Form.Control.Feedback>
                                                </>
                                                
                                            }
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>วันที่สิ้นสุด</Form.Label>
                                            {
                                                mode === 'view' &&
                                                <Form.Label as={Row} className="ms-1"  >{(simulate?.end_date === null)? '-' : simulate?.end_date}</Form.Label>
                                            }
                                            {
                                                mode ==='edit' &&
                                                <>
                                                    <TextDate   name="end_date" 
                                                        value={(simulate?.end_date)}
                                                        placeholder="วันที่สิ้นสุด"
                                                        onChange={handleSetSimulate} />
                                                    <Form.Control.Feedback type="invalid">วันที่ไม่ถูกต้อง!</Form.Control.Feedback>
                                                </>
                                                
                                            }
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>จำนวนครั้งที่ใช้ได้</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Checkbox name='is_infinite_amount' checked={simulate?.is_infinite_amount} onChange={handleSetSimulate} disabled={(mode === 'view') ? true : false} />
                                                {
                                                    simulate?.is_infinite_amount === true &&
                                                    <InputGroup.Text>ไม่จำกัดจำนวนใช้</InputGroup.Text>
                                                }
                                                {
                                                    simulate?.is_infinite_amount === false &&
                                                    <>
                                                        <InputGroup.Text>จำกัดจำนวน โปรดระบุ : </InputGroup.Text>
                                                        <Form.Control type='number' name={'amount'} disabled={(mode === 'view' || simulate?.is_infinite_amount) ? true : false} value={simulate?.amount} required={true} onChange={handleSetSimulate} />
                                                    </>
                                                }
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>ใช้งาน</Form.Label>
                                            <Form.Switch name={'active'}
                                                disabled={(mode === 'view') ? true : false}
                                                checked={simulate?.active}
                                                placeholder="ใช้งาน" 
                                                onChange={handleSetSimulate} />
                                        </Form.Group> 
                                    </Col>
                                    <Col className="me-3">
                                    {
                                        !createMode &&
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="label-title">ผู้บันทึก</Form.Label>
                                            <Form.Label>{simulate?.modify_by}&nbsp;</Form.Label>
                                        </Form.Group>
                                        
                                    }
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="label-title">วันที่บันทึกล่าสุด</Form.Label>
                                            <Form.Label>{ConvertDateTimeToText(simulate?.modify_date)}</Form.Label>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {
                                    alert != '' &&
                                    <div className="alert alert-danger" role="alert">
                                        {alert}
                                    </div>
                                }
                                {
                                    mode !== 'view' &&
                                    <Row>
                                        <Col>
                                        <>
                                        <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                            onClick={handleCancel}  >
                                            ยกเลิก
                                        </Button>
                                        <Button variant="primary" type="submit" className='ps-5 pe-5' disabled={loading} >
                                            {
                                                createMode && <>สร้าง</>
                                            }
                                            {
                                                !createMode && mode === 'edit' && <>บันทึก</>
                                            }
                                            {loading === true && (
                                                <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            )}
                                        </Button>
                                        </>
                                        </Col>
                                    </Row>
                                }
                               
                                
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </Layout4Admin1>
    )
}